<script setup lang="ts">
  import ReminderHistoryView from './ReminderHistoryView.vue';
</script>

<template>
  <ReminderHistoryView initial-tab="general-history" />
</template>
